import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { CallTranscript, Customer, ModelID } from '@/types';
import { get } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';
import { featureKeys, featurePath, TranscriptSearchParams } from '.';

type QueryFnType = typeof fetchTranscripts;

type UseTranscriptsOptions = {
  customer: Customer;
  location: ModelID;
  search?: TranscriptSearchParams;
  config?: QueryConfig<QueryFnType>;
};

export const fetchTranscripts = (
  customer: Customer,
  location: ModelID,
  search: TranscriptSearchParams = {},
) => get<CallTranscript[]>(`${featurePath(customer)}?franchise_id=${location}`, search);

export const useTranscripts = ({
  customer,
  location,
  search = {},
  config = {},
}: UseTranscriptsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: featureKeys.list(location, { customer_id: customer.customer_id, ...search }),
    queryFn: () => fetchTranscripts(customer, location, search),
  });
};
